/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CancelIcon from "@mui/icons-material/Cancel";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { memo, useEffect, useState } from "react";
import {
  dashboardSearchOnOptions,
  filterOptionsInitialValue,
  getDateRangeFromToday
} from "src/helpers/Dashboard";
import { removeUrlParam, setUrlParam } from "src/helpers/Dashboard/resources";
import {
  searchDashboardData,
  setDateFiltersDashboard,
  setFilterOptions,
  setSearchOnDashboard
} from "src/redux/Actions/dashboard";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import useURLQuery from "src/utils/hooks/useQuery";
// import { Button } from "@mui/material";
// import StorageService from "src/utils/Storage/storageService";
// import { roleIDs } from "src/config/constant";
// import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CustomAutocomplete from "src/shared/CustomAutocomplete";
import CustomDateRange from "src/shared/CustomDateRange";
import Resources from "../../../config/Resources";
import PAFUpload from "./PAFUpload";
import QueryFilterModal from "./QueryFilterOptions";

function QueryOptions() {
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isPAFUploadActive, setIsPAFUploadActive] = useState(false);
  const searchValue = useAppSelector((state) => state.dashboard.searchQuery);
  const searchOnValue = useAppSelector((state) => state.dashboard.searchOn);
  const dateFilterValue = useAppSelector((state) => state.dashboard.dateFilters);
  const urlSearch = useURLQuery().get("search");
  const [search, setSearch] = useState(searchValue);
  // const user = StorageService.getFromLocalStorage("user");
  const [searchOn, setSearchOn] = useState(searchOnValue);
  const [dateFilter, setDateFilter] = useState(dateFilterValue);
  // const user = StorageService.getFromLocalStorage("user");
  const dateRange = getDateRangeFromToday(365, "past");

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: filterOptionsInitialValue,
    onSubmit: (fieldValues) => {
      // store.dispatch(setFilterSaved(true));
      store.dispatch(setFilterOptions(fieldValues));
      setIsFilterActive(false);
    },
    onReset: () => {
      store.dispatch(setFilterOptions(filterOptionsInitialValue));
      // setIsFilterActive(false);
    }
  });

  const handleCloseClick = () => {
    setIsFilterActive((prev) => !prev);
  };

  useEffect(() => {
    if (urlSearch) {
      store.dispatch(searchDashboardData(urlSearch || ""));
      setSearch(urlSearch || "");
    }
  }, []);

  const handleDateChange = (name: string, value: any) => {
    setDateFilter((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    store.dispatch(setDateFiltersDashboard(dateFilter));
  }, [dateFilter.endDate, dateFilter.startDate]);
  console.log("dateFilter", dateFilter, searchOn);
  return (
    <>
      {isPAFUploadActive && (
        <PAFUpload
          setActive={() => {
            document.body.style.overflowY = "scroll";
            setIsPAFUploadActive((prev) => !prev);
          }}
        />
      )}
      <QueryFilterModal isOpen={isFilterActive} onCloseClick={handleCloseClick} formik={formik} />
      <div className="flex flex-col items-center justify-between space-x-2 md:mt-0 md:flex-row md:space-y-0">
        <h2 className="hidden font-bold leading-6 md:block xl:text-xl font-montserrat">
          Applications
        </h2>
        <div className="space-y-2 lg:flex lg:space-y-0">
          <div className="flex flex-row items-center pr-2 space-x-5 md:pr-0">
            <div className="flex space-x-2 md:max-sm:flex">
              <div className="w-55">
                <CustomDateRange
                  startLabel="Start Date"
                  endLabel="End Date"
                  startName="startDate"
                  endName="endDate"
                  minDate={dateRange?.minDate}
                  maxDate={dateRange?.maxDate}
                  startValue={dateFilter.startDate}
                  endValue={dateFilter.endDate}
                  setFieldValue={handleDateChange}
                  className="!h-10 !font-montserrat"
                />
              </div>
              <div className="w-40">
                <CustomAutocomplete
                  setFieldTouched={() => {}}
                  onChange={(inputValue) => {
                    if (searchOn !== inputValue) {
                      setSearchOn(inputValue);
                      store.dispatch(setSearchOnDashboard(inputValue));
                      setSearch("");
                      removeUrlParam("search");
                      store.dispatch(searchDashboardData(""));
                    }
                  }}
                  label="Search On"
                  name="searchOn"
                  value={searchOn}
                  setFieldValue={() => {}}
                  error=""
                  options={dashboardSearchOnOptions}
                  className="!h-10 !font-montserrat"
                />
              </div>
              <TextField
                inputMode="search"
                variant="standard"
                margin="none"
                focused={false}
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                InputProps={{
                  startAdornment: (
                    <img
                      src={Resources.images.Dashboard.searchIcon}
                      alt="search"
                      className="ml-2 text-black"
                    />
                  ),
                  endAdornment: (
                    <CancelIcon
                      className="!cursor-pointer !h-5"
                      onClick={() => {
                        setSearch("");
                        if (searchValue) {
                          removeUrlParam("search");
                          store.dispatch(searchDashboardData(""));
                        }
                      }}
                    />
                  ),
                  disableUnderline: true,
                  classes: {
                    inputAdornedStart: "!pl-2",
                    root: "!h-14   !w-auto !px-1 !bg-whiteEdgar !rounded-lg !text-black",
                    input: "!text-black !font-medium !text-sm !font-montserrat"
                  }
                }}
                inputProps={{
                  onKeyPress: (event) => {
                    if (
                      event.key === "Enter" &&
                      (event.target as HTMLInputElement)?.value &&
                      searchValue.trim() !== (event.target as HTMLInputElement)?.value?.trim()
                    ) {
                      setUrlParam((event.target as HTMLInputElement)?.value?.trim());
                      store.dispatch(
                        searchDashboardData((event.target as HTMLInputElement)?.value?.trim())
                      );
                    }
                  }
                }}
                placeholder="Search"
                className="sm:max-md:w-60 lg:w-88"
              />
            </div>
            <div className="hidden sm:flex">
              <div
                onClick={handleCloseClick}
                className="font-montserrat font-medium px-4 py-3 border-1.5 rounded-md border-hotShot flex items-center justify-center md:space-x-2 cursor-pointer"
              >
                <span>Filter by</span>
                <span>
                  <img
                    src={
                      isFilterActive
                        ? Resources.images.Select.upIcon
                        : Resources.images.Select.downIcon
                    }
                    alt="arrow"
                  />
                </span>
              </div>
            </div>
            <div className="sm:hidden">
              <img
                onClick={handleCloseClick}
                src={Resources.images.Dashboard.filterIcon}
                alt="filter"
                className="!text-center"
              />
            </div>
            {/* {(user?.role === roleIDs.nbgo ||
              user?.role === roleIDs.superAdmin ||
              user?.role === roleIDs.admin) && (
              <div>
                <Button
                  variant="contained"
                  classes={{ contained: "!rounded-lg" }}
                  onClick={() => setIsPAFUploadActive((prev) => !prev)}
                  className="rounded-lg"
                >
                  <FileUploadOutlinedIcon fontSize="small" />
                  <span>PAF</span>
                </Button>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(QueryOptions);
